import { render } from "./MarketingCampaignOverview.vue?vue&type=template&id=87b276fa&scoped=true"
import script from "./MarketingCampaignOverview.vue?vue&type=script&lang=js"
export * from "./MarketingCampaignOverview.vue?vue&type=script&lang=js"

import "./MarketingCampaignOverview.vue?vue&type=style&index=0&id=87b276fa&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87b276fa"]])

export default __exports__